import { useMemo } from 'react';
import { keys } from 'lodash-es';

import { aiCohortsColorsMap, aiCohortsMap } from '../configs/constants';

const cohortOrder = keys(aiCohortsMap);
const defaultColor = '#000';

const toCohortEntry = (cohort) => ({
  dataField: cohort,
  text: aiCohortsMap[cohort] || cohort,
  color: aiCohortsColorsMap[cohort] || defaultColor,
});

export default function useTransitionsTableAxes({ data }) {
  return useMemo(() => {
    const tableData = data || {};

    // Cohorts present anywhere in the matrix (top-level keys + their nested keys)
    const presentCohorts = new Set();
    keys(tableData).forEach((key) => {
      if (!tableData[key]) return;
      presentCohorts.add(key);
      keys(tableData[key]).forEach((nestedKey) => presentCohorts.add(nestedKey));
    });

    const columns = cohortOrder.filter((c) => presentCohorts.has(c)).map(toCohortEntry);
    const rows = cohortOrder.filter((c) => tableData?.[c]).map(toCohortEntry);

    return { columns, rows, tableData };
  }, [data]);
}
